// Header 0.5 col padding
// Menu 0.75 col padding
//  Left 2 col width with 0.75 col padding
//  Right 1.75 col width with 0.75 col padding
//
// On 5, looks like 1.25 col width with 0.5 col padding + 3.75 sides
// on 3, looks like 2.25 col width max with 0.5 col padding + 2.25 sides
//

const config = {
  typeData: {
    "bags-and-sleeves": {
      label: "Bags & Sleeves",
      link: "/collections/urban-armor-gear-bags-and-sleeves/",
    },
    gears: {
      label: "Gear",
      link: "/collections/gears/",
    },
    headphones: {
      columns: 2,
      featuredBrands: [
        {
          brand: "apple",
          devicesToShow: 5,
        },
        {
          brand: "samsung",
          devicesToShow: 6,
        },
      ],
      label: "Headphones",
      otherBrands: [],
      otherBrandsLabel: "",
      series: [],
      showClearance: true,
      showOtherBrands: false,
      showSeries: false,
    },
    laptops: {
      columns: 3,
      featuredBrands: [
        {
          brand: "apple",
          devicesToShow: 5,
        },
        {
          brand: "microsoft",
          devicesToShow: 4,
        },
      ],
      label: "Laptop",
      otherBrands: ["dell", "hp-laptops-and-tablets", "lenovo"],
      otherBrandsLabel: "More Laptop Cases",
      series: [],
      showClearance: false,
      showOtherBrands: true,
      showSeries: false,
    },
    phones: {
      columns: 5,
      featuredBrands: [
        {
          brand: "apple",
          devicesToShow: 6,
        },
        {
          brand: "samsung",
          devicesToShow: 6,
        },
        {
          brand: "google",
          devicesToShow: 4,
        },
      ],
      label: "Phone",
      otherBrands: ["motorola", "huawei", "lg", "oneplus", "xiaomi"],
      otherBrandsLabel: "More Phone Cases",
      series: [
        "monarch",
        "pathfinder",
        "civilian",
        "plyo",
        "metropolis",
        "plasma",
      ],
      showClearance: true,
      showOtherBrands: true,
      showSeries: true,
    },
    "power-and-cables": {
      label: "Power",
      link: "/collections/urban-armor-gear-power-and-cables/",
    },
    "special-ops": {
      label: "Original Art",
      link: "/collections/special-ops/",
    },
    tablets: {
      columns: 5,
      featuredBrands: [
        {
          brand: "apple",
          devicesToShow: 6,
        },
        {
          brand: "microsoft",
          devicesToShow: 6,
        },
        {
          brand: "samsung",
          devicesToShow: 6,
        },
      ],
      label: "Tablet",
      otherBrands: ["lg", "tcl"],
      otherBrandsLabel: "More Tablet Cases",
      series: [
        "monarch",
        "pathfinder",
        "civilian",
        "plyo",
        "metropolis",
        "plasma",
      ],
      showClearance: true,
      showOtherBrands: true,
      showSeries: true,
    },
    watches: {
      columns: 3,
      featuredBrands: [
        {
          brand: "apple",
          devicesToShow: 2,
        },
        {
          brand: "samsung",
          devicesToShow: 1,
        },
        {
          brand: "urban-armor-gear",
          devicesToShow: 2,
        },
      ],
      label: "Watch",
      otherBrands: [],
      otherBrandsLabel: "",
      series: [],
      showClearance: false,
      showOtherBrands: false,
      showSeries: false,
    },
  },
  types: [
    "phones",
    "tablets",
    "laptops",
    "special-ops",
    "headphones",
    "watches",
    "power-and-cables",
    "bags-and-sleeves",
    "gears",
  ],
}

export default config
